import React from 'react';
import '../CSS/CategoryMenuItem.css';
import { getItemImageUrl } from '../utils/subdomainUtils';

function CategoryMenuItem({ item, onClick, menuImages }) {
  // Use the centralized image URL function

  return (
    <div className="category-menu-item" onClick={onClick}>
      <div className="menu-tile-image">
        <img
          src={getItemImageUrl(item.item_name, item.category, menuImages)}
          alt={item.item_name}
        />
      </div>
      <div className="item-content">
        <h3 className="item-name">{item.item_name}</h3>
        <p className="item-description">{item.description}</p>
        <div className="item-price">${item.base_price.toFixed(2)}</div>
      </div>
    </div>
  );
}

export default CategoryMenuItem; 